import type { DateField, SelectField } from '@prismicio/client';
import { changeDataFormat } from '@/utils/changeDataFormat';

import styles from './dateTopicInfo.module.scss';

interface DateTopicInfoProps {
  topic: SelectField<'Debt Consolidation' | 'HELOC' | 'Personal loans'>;
  date: DateField;
  fontSize: 'small' | 'regular';
}

export const DateTopicInfo = ({
  topic,
  date,
  fontSize,
}: DateTopicInfoProps) => {
  const formatedDate = changeDataFormat(date);

  return (
    <div className={`${styles.topics_wrapper} ${styles[fontSize]}`}>
      <span>{topic}</span>
      <span className={styles.dot} />
      <span>{formatedDate}</span>
    </div>
  );
};
